import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import Breadcrumb from '@/components/feature/Breadcrumb';
import { aboutData } from '@/mocks/about';

export default function AboutPage() {
  const aboutJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    name: '关于我们 - 亚洲精品视频',
    description: aboutData.introduction,
    url: 'https://beevpn.cn/about',
    isPartOf: {
      '@type': 'WebSite',
      name: '亚洲精品视频',
      url: 'https://beevpn.cn',
    },
    about: {
      '@type': 'Organization',
      name: aboutData.brandName,
      description: aboutData.introduction,
      url: 'https://beevpn.cn',
      contactPoint: {
        '@type': 'ContactPoint',
        telephone: aboutData.contact.phone,
        contactType: 'customer service',
        availableLanguage: ['Chinese'],
      },
      address: {
        '@type': 'PostalAddress',
        streetAddress: aboutData.contact.address,
      },
    },
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(aboutJsonLd)}</script>
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main className="pt-20 pb-14">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="mb-6">
              <Breadcrumb
                items={[
                  { label: '首页', href: '/' },
                  { label: '关于我们' },
                ]}
              />
            </div>

            <section className="mb-16">
              <div className="max-w-3xl">
                <h1 className="text-3xl md:text-4xl font-heading font-bold text-foreground-900 mb-4">
                  关于我们
                </h1>
                <p className="text-lg text-foreground-600 leading-relaxed mb-6">{aboutData.introduction}</p>
              </div>

              <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mt-10">
                {aboutData.stats.map((stat) => (
                  <div
                    key={stat.label}
                    className="p-6 bg-background-100 border border-background-200/70 rounded-lg text-center"
                  >
                    <div className="text-2xl md:text-3xl font-heading font-bold text-primary-500">
                      {stat.value}
                    </div>
                    <div className="text-sm text-foreground-500 mt-1">{stat.label}</div>
                  </div>
                ))}
              </div>
            </section>

            <section className="mb-16">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
                品牌使命
              </h2>
              <p className="text-foreground-600 leading-relaxed max-w-3xl mb-10">{aboutData.mission}</p>

              <div className="bg-background-100 border border-background-200/70 rounded-lg p-8 md:p-10 max-w-3xl">
                <h3 className="text-lg font-heading font-bold text-foreground-900 mb-3">我们的愿景</h3>
                <p className="text-foreground-600 leading-relaxed">{aboutData.vision}</p>
              </div>
            </section>

            <section className="mb-16">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-8">
                平台优势
              </h2>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
                {aboutData.features.map((feature) => (
                  <div
                    key={feature.title}
                    className="p-6 bg-background-100 border border-background-200/70 rounded-lg hover:border-accent-300 transition-colors"
                  >
                    <div className="w-11 h-11 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mb-4">
                      <i className={`${feature.icon} text-lg`}></i>
                    </div>
                    <h3 className="font-semibold text-foreground-900 mb-2 text-sm">{feature.title}</h3>
                    <p className="text-sm text-foreground-500 leading-relaxed">{feature.description}</p>
                  </div>
                ))}
              </div>
            </section>

            <section>
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-8">
                联系我们
              </h2>
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                <div className="space-y-5">
                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 shrink-0">
                      <i className="ri-map-pin-line"></i>
                    </div>
                    <div>
                      <h4 className="font-medium text-foreground-900 text-sm">公司地址</h4>
                      <p className="text-sm text-foreground-500 mt-1">{aboutData.contact.address}</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 shrink-0">
                      <i className="ri-phone-line"></i>
                    </div>
                    <div>
                      <h4 className="font-medium text-foreground-900 text-sm">客服电话</h4>
                      <p className="text-sm text-foreground-500 mt-1">{aboutData.contact.phone}</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 shrink-0">
                      <i className="ri-mail-line"></i>
                    </div>
                    <div>
                      <h4 className="font-medium text-foreground-900 text-sm">电子邮箱</h4>
                      <p className="text-sm text-foreground-500 mt-1">{aboutData.contact.email}</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 shrink-0">
                      <i className="ri-wechat-line"></i>
                    </div>
                    <div>
                      <h4 className="font-medium text-foreground-900 text-sm">微信公众号</h4>
                      <p className="text-sm text-foreground-500 mt-1">{aboutData.contact.wechat}</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 shrink-0">
                      <i className="ri-weibo-line"></i>
                    </div>
                    <div>
                      <h4 className="font-medium text-foreground-900 text-sm">官方微博</h4>
                      <p className="text-sm text-foreground-500 mt-1">{aboutData.contact.weibo}</p>
                    </div>
                  </div>
                </div>

                <div className="bg-background-100 border border-background-200/70 rounded-lg p-8">
                  <h3 className="font-heading font-bold text-foreground-900 text-lg mb-4">发送消息</h3>
                  <form className="space-y-4" data-readdy-form="true" action="https://readdy.ai/api/form/d9tvqatca23r0tr1ann0" method="POST">
                    <div>
                      <input
                        type="text"
                        name="name"
                        placeholder="您的姓名"
                        className="w-full px-4 py-2.5 text-sm bg-background-50 border border-background-300 rounded-md text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors"
                      />
                    </div>
                    <div>
                      <input
                        type="email"
                        name="email"
                        placeholder="您的邮箱"
                        className="w-full px-4 py-2.5 text-sm bg-background-50 border border-background-300 rounded-md text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors"
                      />
                    </div>
                    <div>
                      <textarea
                        name="message"
                        rows={4}
                        placeholder="请输入您的留言..."
                        maxLength={500}
                        className="w-full px-4 py-2.5 text-sm bg-background-50 border border-background-300 rounded-md text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors resize-none"
                      ></textarea>
                    </div>
                    <input
                      type="text"
                      name="phone_alt"
                      tabIndex={-1}
                      autoComplete="off"
                      aria-hidden="true"
                      readOnly
                      className="honeypot-field"
                    />
                    <button
                      type="submit"
                      className="w-full py-2.5 bg-primary-500 text-background-50 text-sm font-medium rounded-md hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                    >
                      发送消息
                    </button>
                  </form>
                </div>
              </div>
            </section>
          </div>
        </main>
        <Footer />
        <ScrollToTop />
      </div>
    </>
  );
}